__webpack_require__.p = "/teacher/";